import React, { createContext, useState, useContext } from "react";
import { GlobalContext } from "./GlobalState";
import { colors } from "../styles/theme";

export const EditContext = createContext();

//----------------------------------------------------------------------------

export const EditProvider = ({ children }) => {
  const { currentSpotlight } = useContext(GlobalContext);

  const initName = currentSpotlight ? currentSpotlight.name : "";
  const initType = currentSpotlight ? currentSpotlight.type : "text";
  const initShowCta = currentSpotlight ? currentSpotlight.headline && currentSpotlight.ctaText.length > 0 : true;
  const initHeadline = currentSpotlight ? currentSpotlight.headline : "";
  const initCta = currentSpotlight ? currentSpotlight.ctaText : "";
  const initLink = currentSpotlight ? currentSpotlight.ctaUrl : "";
  const initPrimaryColor = currentSpotlight
    ? currentSpotlight.primaryColor
    : "#4996E9";
  const initSecondaryColor = currentSpotlight
    ? currentSpotlight.secondaryColor
    : "#FEFEFE";
  const initFileName = currentSpotlight ? currentSpotlight.fileName : "";
  const initFileUrl = currentSpotlight ? currentSpotlight.fileUrl : "";

  const colorOptions = [
    "#4996e9",
    "#1E3290",
    "#003f5c",
    "#4a154b",
    "#bc5090",
    "#ff6361",
    "#ffa600",
    "#211D20",
    "#838c8d",
    "#c2cbcc",
    "#dbe4e5",
    "#fefefe",
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState(initName);
  const [headline, setHeadline] = useState(initHeadline);
  const [ctaText, setCtaText] = useState(initCta);
  const [linkVal, setLinkVal] = useState(initLink);
  const [primaryColor, setPrimaryColor] = useState(initPrimaryColor);
  const [secondaryColor, setSecondaryColor] = useState(initSecondaryColor);
  const [fileName, setFileName] = useState(initFileName);
  const [fileUrl, setFileUrl] = useState(initFileUrl);
  const [type, setType] = useState(initType);
  const [showCta, setShowCta] = useState(initShowCta);

  return (
    <EditContext.Provider
      value={{
        name,
        setName,
        headline,
        setHeadline,
        ctaText,
        setCtaText,
        linkVal,
        setLinkVal,
        primaryColor,
        setPrimaryColor,
        secondaryColor,
        setSecondaryColor,
        colorOptions,
        fileName,
        setFileName,
        fileUrl,
        setFileUrl,
        isLoading,
        setIsLoading,
        type,
        setType,
        showCta,
        setShowCta,
      }}
    >
      {children}
    </EditContext.Provider>
  );
};
